import { ApiRoute } from 'api-base-refrence';
import { InformationApiRoute } from './information.api';

export class ChartNumberProvinceApiRoute extends ApiRoute {
  static apiName = '';
  static parent = InformationApiRoute;
  static urlPattern() {
    return `/chart-number-province`;
  }
}
